export enum LoginAttemptResult {
  Authenticated = 'authenticated',
  PasswordRequired = 'passwordRequired',
  ExternalAuthentication = 'externalAuthentication',
  Failed = 'failed',
}
